import React from "react";

/**
 * Decorative topographic-contour watermark used as the home screen's
 * background flourish. Purely cosmetic — no props, no interaction.
 */
export const HomeWatermark = () => (
  <svg
    aria-hidden
    className="pointer-events-none absolute inset-0 w-full h-full opacity-[0.05] dark:opacity-[0.08] text-mali-navy dark:text-white"
    viewBox="0 0 400 800"
    fill="none"
    preserveAspectRatio="xMidYMid slice"
  >
    <path d="M-20 180 C 80 120, 200 240, 320 160 S 480 180, 540 140" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M-40 320 C 90 240, 220 380, 350 280 S 480 320, 560 260" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M-20 480 C 100 400, 220 540, 360 460 S 480 480, 560 420" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M-40 640 C 90 560, 220 700, 350 600 S 480 640, 560 580" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M-20 800 C 80 720, 200 860, 320 760 S 480 800, 540 740" stroke="currentColor" strokeWidth="1.5" fill="none" />
  </svg>
);
